import { render, staticRenderFns } from "./FaqsModal.vue?vue&type=template&id=572b527f&scoped=true"
import script from "./FaqsModal.vue?vue&type=script&lang=js"
export * from "./FaqsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b527f",
  null
  
)

export default component.exports